"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareSheetPopup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const ShareSheet_1 = require("../ShareSheet");
const web_popup_1 = require("@snapchat/web-popup");
const ShareSheetPopup_module_css_1 = __importDefault(require("./ShareSheetPopup.module.css"));
const ShareSheetPopupState_1 = require("./ShareSheetPopupState");
/**
 * component used to render share options on story/spotlight videos on mobile
 */
function ShareSheetPopup(props) {
    return ((0, jsx_runtime_1.jsx)(web_popup_1.Popup, { children: (0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(ShareSheetPopup_module_css_1.default.container, ShareSheetPopup_module_css_1.default.openStyle, {
                [ShareSheetPopup_module_css_1.default.closeStyle]: props.isVisible === ShareSheetPopupState_1.ShareSheetPopupState.INVISIBLE,
            }), children: (0, jsx_runtime_1.jsx)(ShareSheet_1.ShareSheet, { ...props }) }) }));
}
exports.ShareSheetPopup = ShareSheetPopup;
//# sourceMappingURL=index.js.map